import React from 'react';
import { UserInfoTooltipProps } from './types';
import { TooltipContent, TooltipRow, TypographyLink } from './user-info-tooltip.styles';
import { Typography } from '../typography/typography';
import { Tooltip } from '@vtbhome/juicyfront';
import { StatusInfoOutline } from '@vtbhome/juicyfront/indexIcon';

export const UserInfoTooltip: React.FC<UserInfoTooltipProps> = ({ tooltipData, tooltipProps }) => {
    return (
        <Tooltip {...tooltipProps}>
            <StatusInfoOutline />
            {tooltipData && (
                <TooltipContent>
                    {tooltipData.departmentName && (
                        <TooltipRow>
                            <Typography size='body2_long' color='neutral_90'>
                                Отдел
                            </Typography>
                            <Typography size='body2_long' color='neutral_50'>
                                {tooltipData.departmentName}
                            </Typography>
                        </TooltipRow>
                    )}
                    {tooltipData.email && (
                        <TooltipRow>
                            <Typography size='body2_long' color='neutral_90'>
                                Почта
                            </Typography>
                            <TypographyLink href={`mailto:${tooltipData.email}`}>{tooltipData.email}</TypographyLink>
                        </TooltipRow>
                    )}
                    {tooltipData.phoneNumber && (
                        <TooltipRow>
                            <Typography size='body2_long' color='neutral_90'>
                                Телефон
                            </Typography>
                            <TypographyLink href={`tel:${tooltipData.phoneNumber}`}>
                                {tooltipData.phoneNumber}
                            </TypographyLink>
                        </TooltipRow>
                    )}
                </TooltipContent>
            )}
        </Tooltip>
    );
};
